import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '../guards/module-import.guard';
import { AuthService } from './auth.service';
import { ThemeSwitcherService } from './theme-switcher.service';
import { SpinnerService } from './spinner.service';
import { ToastrService } from './toastr.service';
import { MessageService } from 'primeng/api';
import { DateService } from './date.service';
import { NotifyService } from './notify.service';
import { StepperService } from './stepper.service';
import { JobsService } from './jobs.service';
import { StructureOrganizativeService } from './structure-organizative.service';
import { FlowService } from './flow.service';
import { VersionService } from './version.service';
import { TypeValorationReportService } from './type-valoration-report.service';
import { TypeStatusReportService } from './type-status-report.service';
import { TypeDocumentService } from './type-document.service';
import { ReportService } from './report.service';
import { TypeStructureReportService } from './type-structure-report.service';
import { FileService } from './file.service';
import { FormsErrorsService } from './forms-error.service';
import { CacheService } from './cache.service';
import { ActionPlanService } from './action-plan.service';

const SERVICES = [
    ThemeSwitcherService,
    AuthService,
    SpinnerService,
    MessageService,
    ToastrService,
    DateService,
    NotifyService,
    StepperService,
    JobsService,
    StructureOrganizativeService,
    FlowService,
    VersionService,
    TypeDocumentService,
    TypeValorationReportService,
    TypeStatusReportService,
    ReportService,
    TypeStructureReportService,
    FileService,
    FormsErrorsService,
    CacheService,
    ActionPlanService
]

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
    ],
    declarations: [],
})
export class ServicesModule {
    constructor(@Optional() @SkipSelf() parentModule: ServicesModule) {
        throwIfAlreadyLoaded(parentModule, 'ServicesModule');
    }
    static forRoot(environment: any): ModuleWithProviders<ServicesModule> {
        return {
            ngModule: ServicesModule,
            providers: [
                ...SERVICES,
                {
                    provide: 'environment',
                    useValue: environment
                }
            ],
        };
    }
}